import React, { Component } from 'react'
import Store from 'app/stores/research/pgs/dataManage'
import DataHeader from './containers/DataHeader'
import DataTable from './containers/DataTable'
import dataIcon from "app/styles/images/sp/data-selected.svg"
import "./Index.scss"

export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }
  render() {
    return (
      <div className="datamanage-page research">
        <h2 className="page-title"><img alt="" src={dataIcon} />PGS家系管理</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={this.store} />
        </div>
        <div>
          <DataTable store={this.store} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage/index.js